import { useState, useEffect } from 'react';
import { isPlatformSafari } from './platform.is-safari.js';

function isPlatformAndroid() {
  return /(android)/i.test(navigator.userAgent);
}
function usePlatformAndroid() {
  const [isMatch, setIsMatch] = useState(false);
  useEffect(() => {
    setIsMatch(isPlatformSafari());
  }, []);
  return isMatch;
}

export { isPlatformAndroid, usePlatformAndroid };
//# sourceMappingURL=platform.is-android.js.map
